import DepartamentDetailTabBrand from '@/components/departament/brand/DetailTabBrand.vue'
import brandModalRouter from '@/router/routers/brandModal'

const brandRouter = (beforeEnter, name, singleName, basePath, tabs) => {
    return {
        beforeEnter: beforeEnter,
        name: `${singleName}DetalheAbaMarcas`,
        path: `${basePath}/detalhe/:id/marcas`,
        meta: {
            requiresAuth: true,
            isEmployee: true,
            layout: 'default',
            basePath,
            singleName,
            addRoute: `CadastrarMarca${singleName}`,
            requesterType: basePath.replace('/', ''),
            detailTo: `DetalheMarca${singleName}`,
            tabs
        },
        props: true,
        component: DepartamentDetailTabBrand,
        children: [
            brandModalRouter(beforeEnter, `CadastrarMarca${singleName}`, `/:requesterType/detalhe/:requesterId?/marcas`, false),
            brandModalRouter(beforeEnter, `DetalheMarca${singleName}`, `/:requesterType/detalhe/:requesterId?/marcas/detalhe`, true)
        ]
    }
}

export default brandRouter
